<template>
    <div class="popup-attention">
        <div class="popup-attention__content">
            <h2 class="popup-attention__title-big" v-html="popupData.title"></h2>
            <h3 class="popup-attention__title popup__title" v-html="popupData.text"></h3>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'Error',
        computed: {
            popupData() {
                return this.$store.getters['GET_POPUP_DATA'];
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Error.vue?18c5db9d